export enum MovePageErrors {
    ClusterNotSpecified = 'CLUSTER_NOT_SPECIFIED',
    TooLongName = 'TOO_LONG_NAME',
    IntoSelf = 'INTO_SELF',
    ClusterNotExists = 'CLUSTER_NOT_EXISTS',
    OverrideAttempt = 'OVERRIDE_ATTEMPT',
    SourceReserved = 'SOURCE_RESERVED',
    DestinationReserved = 'DESTINATION_RESERVED',
    ClusterPermissionDenied = 'CLUSTER_PERMISSION_DENIED',
    BecomeNotAccessible = 'BECOME_NOT_ACCESSIBLE',
    NextToHasWrongCluster = 'NEXT_TO_HAS_WRONG_CLUSTER',
    NextToNotSet = 'NEXT_TO_NOT_SET',
    OperationLimitExceeded = 'OPERATION_LIMIT_EXCEEDED',
    General = 'GENERAL',
}
